var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctBoolean, FctTimestamp, FctValue, isVariable } from '../../../../Fct/generics';
import { FaExchangeAlt } from 'react-icons/fa';
import { getAllCurrencies, getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESS } from '../../../../Fct/plugins/uniswap/constants';
import { getMethodName } from '../../../../Fct/plugins/uniswap/helpers/getMethodName';
import { getIsNative } from '../../../../Fct/plugins/uniswap/helpers/getToken';
import { WETH9 } from '@uniswap/sdk-core';
import { ROUTER_V2_ADDRESSES } from '../constants';
import { currencyToWei } from '../../../../Fct/helpers';
export var SimpleSwapV2 = createPlugin({
    protocol: 'UNISWAP',
    type: 'ACTION',
    method: 'swapExactTokensForTokens',
    name: 'simpleSwapV2',
    supportedContracts: ROUTER_V2_ADDRESSES,
    initParams: {
        isExactIn: 'true',
        snipperMode: 'false',
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
            amountOutMin: '0',
            amountInMax: '0',
        },
    },
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                value: new FctValue({ required: false, readonly: true, decimals: 18 }),
                addressIn: new FctAddress({
                    destination: 'erc20',
                    mode: 'INPUT',
                    options: getAllCurrencies({ chainId: chainId }),
                    isPreview: true,
                    icon: FaExchangeAlt,
                }),
                amountIn: new FctValue({
                    destination: 'wei_amount',
                    isPreview: true,
                }),
                addressOut: new FctAddress({
                    destination: 'erc20',
                    mode: 'INPUT',
                    options: getAllCurrencies({ chainId: chainId }),
                    isPreview: true,
                }),
                amountOut: new FctValue({
                    destination: 'wei_amount',
                }),
                isExactIn: new FctBoolean({}),
                snipperMode: new FctBoolean({}),
                methodParams: {
                    amountIn: new FctValue({ destination: 'wei_amount', readonly: true }),
                    amountOutMin: new FctValue({
                        destination: 'wei_amount',
                        readonly: true,
                        required: false,
                    }),
                    amountOut: new FctValue({ destination: 'wei_amount', readonly: true, virtual: true }),
                    amountInMax: new FctValue({ destination: 'wei_amount', readonly: true, virtual: true, required: false }),
                    path: new FctAddressList({
                        destination: 'ERC20_List',
                        readonly: true,
                        options: getSupportedTokens({ chainId: chainId }),
                    }),
                    to: new FctAddress({ isPreview: true }),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2, innerType: 'uint256[]' }),
                amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1, innerType: 'uint256[]' }),
            },
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, output = _a.output, chainId = _a.chainId, setMethod = _a.setMethod;
        var getPathParams = function (_a) {
            var service = _a.service;
            return __awaiter(void 0, void 0, void 0, function () {
                var isSnipperMode, isExactIn, uniswapService, tokenInAddress, tokenOutAddress, defaultReturn, decimalsIn, decimalsOut, amountIn, amountOut, getAmount, amount, initParamsExactIn, initParamsExactOut, res_1, path, swapPath, method, isNativeToken_1, _e, amountIn_1, amountOutMin, amountOut_1, amountInMax, getValue, paramsExactIn, paramsExactOut, e_1;
                var _f, _g, _h, _j;
                return __generator(this, function (_k) {
                    switch (_k.label) {
                        case 0:
                            if (!service)
                                return [2 /*return*/];
                            isSnipperMode = input.snipperMode.value === 'true';
                            isExactIn = input.isExactIn.value !== 'false';
                            uniswapService = service;
                            tokenInAddress = input.addressIn.value;
                            tokenOutAddress = input.addressOut.value;
                            defaultReturn = isExactIn
                                ? {
                                    params: {
                                        amountOut: undefined,
                                        methodParams: { path: undefined, method: undefined, amount: undefined },
                                    },
                                    error: undefined,
                                }
                                : {
                                    params: {
                                        amountIn: undefined,
                                        methodParams: { path: undefined, method: undefined, amount: undefined },
                                    },
                                    error: undefined,
                                };
                            if (!tokenInAddress ||
                                !tokenOutAddress ||
                                typeof tokenInAddress !== 'string' ||
                                typeof tokenOutAddress !== 'string')
                                return [2 /*return*/, defaultReturn];
                            decimalsIn = ((_f = input.amountIn) === null || _f === void 0 ? void 0 : _f.decimals) !== undefined ? (_g = input.amountIn) === null || _g === void 0 ? void 0 : _g.decimals : 18;
                            decimalsOut = ((_h = input.amountOut) === null || _h === void 0 ? void 0 : _h.decimals) !== undefined ? (_j = input.amountOut) === null || _j === void 0 ? void 0 : _j.decimals : 18;
                            amountIn = output.amountIn, amountOut = output.amountOut;
                            amountIn.decimals = decimalsIn;
                            amountOut.decimals = decimalsOut;
                            if (isExactIn) {
                                input.amountIn.readonly = false;
                                input.amountOut.readonly = true;
                            }
                            if (!isExactIn) {
                                input.amountIn.readonly = true;
                                input.amountOut.readonly = false;
                            }
                            getAmount = function () {
                                if (isExactIn) {
                                    if (isVariable(input.amountIn.value)) {
                                        if (input.amountIn.estimatedValue !== '0' && input.amountIn.estimatedValue) {
                                            return input.amountIn.estimatedValue;
                                        }
                                        return currencyToWei(1, decimalsIn);
                                    }
                                    return input.amountIn.value;
                                }
                                if (isVariable(input.amountOut.value)) {
                                    if (input.amountOut.estimatedValue && input.amountOut.estimatedValue !== '0') {
                                        return input.amountOut.estimatedValue;
                                    }
                                    return currencyToWei(1, decimalsOut);
                                }
                                return input.amountOut.value;
                            };
                            amount = getAmount();
                            if (amount === undefined)
                                return [2 /*return*/, defaultReturn];
                            initParamsExactIn = {
                                value: undefined,
                                amountOut: undefined,
                                methodParams: { path: undefined, amountOut: undefined, amountOutMin: undefined },
                            };
                            initParamsExactOut = {
                                value: undefined,
                                amountIn: undefined,
                                methodParams: { path: undefined, amountIn: undefined, amountInMax: undefined },
                            };
                            _k.label = 1;
                        case 1:
                            _k.trys.push([1, 5, , 6]);
                            res_1 = {
                                inputAmount: undefined,
                                outputAmount: undefined,
                                path: undefined,
                            };
                            if (!isSnipperMode) return [3 /*break*/, 2];
                            path = [tokenInAddress, tokenOutAddress].map(function (tokenAddress) {
                                if (getIsNative(tokenAddress))
                                    return WETH9[Number(chainId)].address;
                                return tokenAddress;
                            });
                            if (isExactIn) {
                                res_1 = {
                                    inputAmount: undefined,
                                    outputAmount: '0',
                                    path: path,
                                };
                            }
                            else {
                                res_1 = {
                                    inputAmount: '0',
                                    outputAmount: undefined,
                                    path: path,
                                };
                            }
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, uniswapService.create({
                                cmd: 'simulateSwap',
                                protocol: 'uniswap',
                                token_in: tokenInAddress,
                                token_in_decimals: decimalsIn,
                                token_out: tokenOutAddress,
                                token_out_decimals: decimalsOut,
                                token_amount: amount,
                                version: 'v2',
                                type: isExactIn ? 'in' : 'out',
                            })];
                        case 3:
                            res_1 = (_k.sent());
                            _k.label = 4;
                        case 4:
                            swapPath = res_1 === null || res_1 === void 0 ? void 0 : res_1.path;
                            if (!swapPath) {
                                return [2 /*return*/, {
                                        params: isExactIn ? initParamsExactIn : initParamsExactOut,
                                        error: 'invalid trade',
                                    }];
                            }
                            method = getMethodName({
                                isExactInput: isExactIn,
                                protocol: 'V2',
                                isInputNative: getIsNative(tokenInAddress),
                                isOutputNative: getIsNative(tokenOutAddress),
                            });
                            if (setMethod)
                                setMethod(method);
                            isNativeToken_1 = method === 'swapETHForExactTokens' || method === 'swapExactETHForTokens';
                            _e = input.methodParams, amountIn_1 = _e.amountIn, amountOutMin = _e.amountOutMin, amountOut_1 = _e.amountOut, amountInMax = _e.amountInMax;
                            amountIn_1.virtual = false;
                            amountOutMin.virtual = false;
                            amountOutMin.readonly = true;
                            switch (method) {
                                case 'swapExactETHForTokens':
                                    amountIn_1.virtual = true;
                                    amountOutMin.virtual = false;
                                    amountOutMin.readonly = false;
                                    amountInMax.virtual = true;
                                    amountOut_1.virtual = true;
                                    amountInMax.readonly = true;
                                    amountInMax.hidden = true;
                                    break;
                                case 'swapETHForExactTokens':
                                    amountIn_1.virtual = true;
                                    amountOutMin.virtual = true;
                                    amountInMax.virtual = true;
                                    amountOut_1.virtual = false;
                                    amountInMax.readonly = true;
                                    amountInMax.hidden = true;
                                    break;
                                case 'swapExactTokensForETH':
                                    amountIn_1.virtual = false;
                                    amountOutMin.virtual = false;
                                    amountOutMin.readonly = false;
                                    amountOut_1.virtual = true;
                                    amountInMax.virtual = true;
                                    amountInMax.readonly = true;
                                    amountInMax.hidden = true;
                                    break;
                                case 'swapExactTokensForTokens':
                                    amountIn_1.virtual = false;
                                    amountOutMin.virtual = false;
                                    amountOutMin.readonly = false;
                                    amountOut_1.virtual = true;
                                    amountInMax.virtual = true;
                                    amountInMax.readonly = true;
                                    amountInMax.hidden = true;
                                    break;
                                case 'swapTokensForExactTokens':
                                    amountIn_1.virtual = true;
                                    amountOutMin.virtual = true;
                                    amountOut_1.virtual = false;
                                    amountInMax.virtual = false;
                                    amountInMax.readonly = false;
                                    amountInMax.hidden = false;
                                    break;
                                case 'swapTokensForExactETH':
                                    amountIn_1.virtual = true;
                                    amountOutMin.virtual = true;
                                    amountOut_1.virtual = false;
                                    amountInMax.virtual = false;
                                    amountInMax.readonly = false;
                                    amountInMax.hidden = false;
                                    break;
                            }
                            getValue = function () {
                                if (!isNativeToken_1)
                                    return '0';
                                if (isVariable(input.amountIn.value)) {
                                    input.value.estimatedValue = res_1.inputAmount;
                                    amountIn_1.estimatedValue = res_1.inputAmount;
                                    return input.amountIn.value;
                                }
                                return res_1.inputAmount;
                            };
                            if (isVariable(input.amountIn.value)) {
                                input.value.estimatedValue = res_1.inputAmount;
                                amountIn_1.estimatedValue = res_1.inputAmount;
                            }
                            if (isVariable(input.amountOut.value)) {
                                amountOut_1.estimatedValue = res_1.outputAmount;
                            }
                            paramsExactIn = {
                                value: getValue(),
                                amountOut: res_1.outputAmount,
                                methodParams: {
                                    path: swapPath,
                                    amountOut: res_1.outputAmount,
                                    amountOutMin: '0',
                                    amountIn: undefined,
                                    amountInMax: undefined,
                                },
                            };
                            paramsExactOut = {
                                value: getValue(),
                                amountIn: res_1.inputAmount,
                                methodParams: {
                                    path: swapPath,
                                    amountIn: res_1.inputAmount,
                                    amountInMax: res_1.inputAmount,
                                    amountOut: undefined,
                                    amountOutMin: undefined,
                                },
                            };
                            return [2 /*return*/, {
                                    params: isExactIn ? paramsExactIn : paramsExactOut,
                                    error: undefined,
                                }];
                        case 5:
                            e_1 = _k.sent();
                            return [2 /*return*/, {
                                    params: isExactIn ? initParamsExactIn : initParamsExactOut,
                                    error: e_1.message,
                                }];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        var getDepParams = function () {
            var isExactIn = input.isExactIn.value === 'true';
            return isExactIn
                ? ['addressIn', 'addressOut', 'isExactIn', 'snipperMode', 'amountIn']
                : ['addressIn', 'addressOut', 'isExactIn', 'snipperMode', 'amountOut'];
        };
        return {
            get: getPathParams,
            depParamKeys: getDepParams,
        };
    },
    requiredApprovals: function (params, chainId, _b, _c, _d, method) {
        if (method === 'swapETHForExactTokens')
            return [];
        if (method === 'swapExactETHForTokens')
            return [];
        var _a = params.methodParams, path = _a.path, amountIn = _a.amountIn;
        return [
            {
                to: path.value && path.value.length ? path.value[0] : undefined,
                params: { spender: ROUTER_V2_ADDRESS[chainId], amount: amountIn.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var to = params.to, amountIn = params.amountIn, amountOut = params.amountOut, addressIn = params.addressIn, addressOut = params.addressOut;
        if (!to.value || !amountIn.value || !amountOut.value || !addressIn.value || !addressOut.value || !vaultAddress)
            return [];
        if (typeof to.value !== 'string' ||
            typeof amountIn.value !== 'string' ||
            typeof amountOut.value !== 'string' ||
            typeof addressIn.value !== 'string' ||
            typeof addressOut.value !== 'string')
            return [];
        return [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: addressIn.value,
                        amount: amountIn.value,
                    },
                ],
                toReceive: [
                    {
                        token: addressOut.value,
                        amount: amountOut.value,
                    },
                ],
            },
        ];
    },
});
